import React, { useEffect } from "react";
import { SeriesDataType, YAsix } from "../types/TrendChartDataType";
// import the core library.
import ReactEChartsCore from "echarts-for-react/lib/core";
// Import the echarts core module, which provides the necessary interfaces for using echarts.
import * as echarts from "echarts/core";

type PropType = {
  xAxisData: string[];
  yAxisData: YAsix[];
};

function TrendLineChart({ xAxisData, yAxisData }: PropType) {
  const serisData: SeriesDataType[] = yAxisData.map((item) => ({
    name: item.name,
    type: "line",
    barGap: 0,
    //label: labelOption,
    emphasis: {
      focus: "series",
    },
    data: item.data,
  }));

  var option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      data: xAxisData,
    },
    toolbox: {
      show: true,
      orient: "vertical",
      left: "right",
      top: "center",
      feature: {
        mark: { show: false },
        dataView: { show: false, readOnly: false },
        magicType: { show: false, type: ["line", "bar", "stack"] },
        restore: { show: false },
        saveAsImage: { show: false },
      },
    },
    xAxis: [
      {
        type: "category",
        axisTick: { show: false },
        data: xAxisData,
      },
    ],
    yAxis: [
      {
        type: "value",
      },
    ],
    series: serisData,
  };

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={option}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      key={JSON.stringify(option)}
    />
  );
}

export default TrendLineChart;
